
import React, { useContext, useEffect } from "react";
import styles from "./style.module.css";
import { useSelector } from "react-redux";
import CircleLoader from "../CircleLoader";
import { ThemeContext } from "ThemeContext";

const Loader = ({ children }) => {

  const pending = useSelector(({ main }) => main.pending);
  const { currentLanguage } = useSelector(({ main }) => main);
  const { theme, toggleTheme } = useContext(ThemeContext);

  useEffect(() => {
    if (pending) {
      document.body.style.overflow = "hidden";
    }
    else {
      document.body.style.overflow = "auto";
    }
  }, [pending]);

  return (
    <div>
      {pending && (
        <div className={styles.background}>
          <div>
            <img
              style={{
                width: window.innerWidth > 400 ? "200px" : "150px",
                height: "auto",
                objectFit: "contain",
              }}
              src={
                currentLanguage === "hy"
                  ? theme === "day" ? "https://vlv.am/public/logos/header_hy.svg" : "https://vlv.am/public/logos/header_hy_night.svg"
                  : theme === "day" ? "https://vlv.am/public/logos/header_ru.svg" : "https://vlv.am/public/logos/header_ru_night.svg"
              }
              alt="Logo"
            />
            <CircleLoader containerStyle={{ height: "100px" }} />
            {/* <div className={styles.dotsContainer}>
              <span className={`${styles.dot} ${styles.dot1}`}></span>
              <span className={`${styles.dot} ${styles.dot2}`}></span>
              <span className={`${styles.dot} ${styles.dot3}`}></span>
              <span className={`${styles.dot} ${styles.dot4}`}></span>
            </div> */}
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default Loader;
